import DOMPurify from "dompurify";

// Usato sia per l'anteprima nell'editor admin (RichTextEditor) sia per il
// rendering pubblico di product.long_description (ProductDetail): quel
// campo è HTML libero scritto da un admin e salvato così com'è nel DB, va
// sempre sanificato appena prima di finire in dangerouslySetInnerHTML,
// anche lato pubblico, indipendentemente da quanto ci fidiamo di chi scrive.
export function sanitizeHtml(html: string): string {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      "p", "br", "strong", "em", "u", "s",
      "h2", "h3", "h4",
      "ul", "ol", "li",
      "table", "thead", "tbody", "tr", "th", "td",
      "a", "span", "div",
    ],
    ALLOWED_ATTR: ["href", "target", "rel", "class"],
  });
}
